<app-action-button-with-embedded-spinner [actionObservable]="updateProcessEventsStatistic.bind(this)" [icon]="'replay'"
    [hint]="'Update Statistic'"></app-action-button-with-embedded-spinner>
